import { createRef } from 'react';

import { Divider } from '@material-ui/core/';

import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';

import { scroller } from '@/src/lib/utils';

import About from './About';
import Contact from './Contact';
import Faq from './Faq';
import Features from './Features';
import Hero from './Hero';
import Partners from './Partners';
import Pricings from './Pricings';
import Reviews from './Reviews';
import Services from './Services';

const sliceRender = ({ slice, refs, index }) => {
  const { slice_type: sliceType, items = [], primary = {} } = slice;

  switch (sliceType) {
    case 'divider':
      return <Divider key={index.toString()} />;
    case 'about':
      return (
        <About
          key={index.toString()}
          section={primary.section_variant}
          image={primary.image}
          title={primary.title}
          subtitle={primary.subtitle}
          features={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'contact':
      return (
        <Contact
          key={index.toString()}
          section={primary.section_variant}
          image={primary.image}
          title={primary.title}
          subtitle={primary.subtitle}
          label={primary.label}
          typed={RichText.asText(primary.typed) || ''}
          features={RichText.asText(primary.features) || ''}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'faq':
      return (
        <Faq
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          cta={primary.cta}
          href={primary.href}
          questions={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'features':
      return (
        <Features
          key={index.toString()}
          section={primary.section_variant}
          image={primary.image}
          title={primary.title}
          subtitle={primary.subtitle}
          highlight={primary.highlight}
          numbers={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'hero':
      return (
        <Hero
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          label={primary.label}
          image={primary.image}
          cta={primary.cta}
          ctaHref={primary.cta_href}
          customStyle={primary.style}
          refElem={refs[primary.ref_id]}
          onLearnMore={() =>
            setTimeout(
              () => scroller(refs[primary.learnmore_ref_id]?.current?.offsetTop - 200),
              500,
            )
          }
        />
      );
    case 'partners':
      return (
        <Partners
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          partners={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'pricing':
      return (
        <Pricings
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          pricingGroups={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'reviews':
      return (
        <Reviews
          key={index.toString()}
          section={primary.section_variant}
          title={primary.title}
          subtitle={primary.subtitle}
          reviews={items}
          refElem={refs[primary.ref_id]}
        />
      );
    case 'services':
      return (
        <Services
          key={index.toString()}
          section={primary.section_variant}
          services={items}
          refElem={refs[primary.ref_id]}
        />
      );
    default:
      return null;
  }
};

export default function SliceZone({ slices }) {
  const refs = slices.reduce((acc, slice) => {
    const { ref_id: refId } = slice?.primary;
    return refId ? { ...acc, [refId]: createRef() } : { ...acc };
  }, {});

  return <>{slices.map((slice, index) => sliceRender({ slice, refs, index }))}</>;
}

SliceZone.propTypes = {
  slices: PropTypes.array,
};
